// FS-2026-065: confirmations stay outside the document scroll area.
import type { PropsWithChildren, ReactNode } from "react";
import { DialogActions, Stack } from "@mui/material";

export const legalDialogPaperSx = {
  m: { xs: 1, sm: 4 },
  width: { xs: "calc(100% - 16px)", sm: "calc(100% - 64px)" },
  maxHeight: { xs: "calc(100% - 16px)", sm: "calc(100% - 64px)" },
  overflow: "hidden",
};

export default function LegalAcceptanceActions({
  confirmations,
  children,
}: PropsWithChildren<{ confirmations?: ReactNode }>) {
  return (
    <DialogActions
      disableSpacing
      sx={{
        display: "block",
        flexShrink: 0,
        bgcolor: "background.paper",
        p: { xs: 1.5, sm: 2 },
        "& > :not(:first-of-type)": { ml: 0 },
      }}
    >
      {confirmations && (
        <Stack
          spacing={0.25}
          sx={{
            "& .MuiFormControlLabel-root": { m: 0, alignItems: "flex-start" },
            "& .MuiCheckbox-root": { p: 0.75, mr: 0.5 },
            "& .MuiFormControlLabel-label": {
              typography: { xs: "body2", sm: "body1" },
              py: 0.75,
              overflowWrap: "anywhere",
            },
          }}
        >
          {confirmations}
        </Stack>
      )}
      <Stack
        direction="row"
        justifyContent="flex-end"
        gap={1}
        useFlexGap
        flexWrap="wrap"
        sx={{
          mt: confirmations ? 1 : 0,
          "& > .MuiButton-root": { minHeight: 40 },
        }}
      >
        {children}
      </Stack>
    </DialogActions>
  );
}
